import { render, staticRenderFns } from "./SalaryView.vue?vue&type=template&id=0d044ccb&"
import script from "./SalaryView.vue?vue&type=script&lang=js&"
export * from "./SalaryView.vue?vue&type=script&lang=js&"
import style0 from "./SalaryView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports